import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { FuseSharedModule } from '@barebone-fuse/@fuse/shared.module';
import { SharedModule } from '@shared/shared.module';
import { AlertTitleCellViewerComponent } from './components/cell-components/alert-title-cell-viewer/alert-title-cell-viewer.component';
import { NotificationContentComponent } from './components/notification-content/notification-content.component';
import { notificationsRoutes } from './notifications.route';
import { NotificationsEffects } from './store/effects/notifications.effects';
import { notificationsReducer } from './store/reducers/notifications.reducers';
import { NotificationStateCellViewerComponent } from './components/cell-components/notification-state-cell-viewer/notification-state-cell-viewer.component';

@NgModule({
  declarations: [
    NotificationContentComponent,
    AlertTitleCellViewerComponent,
    NotificationStateCellViewerComponent
  ],
  imports: [
    RouterModule.forChild(notificationsRoutes),
    EffectsModule.forFeature([NotificationsEffects]),
    StoreModule.forFeature('notifications', notificationsReducer),
    SharedModule
  ],
  exports: []
})
export class NotificationsModule { }
